// Libraries
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { History } from 'history';

// PostMessages
import { AbstractStrategy } from './abstract-strategy';

// Redux
import { getPortfolioById } from '@/redux/modules/portfolios';
import { loadPortfolioForEdit, transformFDC3ToCapIntelPortfolio } from '@/redux/modules/edit-portfolio';

// Types
import { PortfolioFDC3 } from '@/types/portfolio-fdc3';
import { ReduxState } from '@/redux/modules/types';

// Utils
import disclaimers from '@/utils/disclaimers';
import { addPortfoliosToComparison } from '@/redux/modules/comparison';
import { clonePortfolioAsProxy, loadPortfolioIfHoldingsAreMissing } from '@/utils/portfolio/utils';
import { NAV_PATHS } from '@/utils/constants';

export class GetAccountPortfoliosStrategy extends AbstractStrategy {
  async execute(dispatch: ThunkDispatch<ReduxState, null, AnyAction>, context: PortfolioFDC3[], history: History<unknown>): Promise<void> {
    history.push(NAV_PATHS.COMPARISON);
    const portfolio = await dispatch(transformFDC3ToCapIntelPortfolio(context[0]));

    const hasMissingHoldings = disclaimers.portfolioHasMissingOrInvalidHoldings(portfolio);

    if (hasMissingHoldings) {
      // Show the Portfolio Editor with the missing holdings and go through the Missing Item flow
      const portfolioToLoad = await loadPortfolioIfHoldingsAreMissing(portfolio, (id, portfolioType, contact, enterprise, errorWhiteList, source) =>
        dispatch(getPortfolioById(id, portfolioType, contact, enterprise, errorWhiteList, source)),
      );

      const clonedPortfolio = clonePortfolioAsProxy(portfolioToLoad);

      await dispatch(loadPortfolioForEdit(clonedPortfolio));
    } else {
      // Add the portfolio to comparison
      await dispatch(addPortfoliosToComparison([portfolio]));
    }
  }
}
